"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getGenerationFailureDefinitionForMessage = exports.GENERATION_FAILURE_DEFINITIONS_BY_CODE = exports.GenerationFailureCode = void 0;
exports.GenerationFailureCode = {
    SeedanceFaceReferenceUnsupported: 'SEEDANCE_FACE_REFERENCE_UNSUPPORTED',
    SeedanceFalValidation: 'SEEDANCE_FAL_VALIDATION',
    SeedanceSensitiveOutput: 'SEEDANCE_SENSITIVE_OUTPUT',
    SeedanceCopyrightRestriction: 'SEEDANCE_COPYRIGHT_RESTRICTION',
    HiggsfieldPlanRequired: 'HIGGSFIELD_PLAN_REQUIRED',
};
exports.GENERATION_FAILURE_DEFINITIONS_BY_CODE = {
    [exports.GenerationFailureCode.SeedanceFaceReferenceUnsupported]: {
        code: exports.GenerationFailureCode.SeedanceFaceReferenceUnsupported,
        message: 'References with visible faces are not currently supported for this video path. Retrying with the same asset will not resolve it. Use a logo, product image, or another reference without visible faces, or describe the subject in text instead of attaching the face image.',
        presentation: {
            title: 'Reference face not supported',
            summary: 'Use a logo, product image, or another reference without visible faces, or describe the subject in text. Retrying this same asset will not fix it.',
        },
    },
    [exports.GenerationFailureCode.SeedanceFalValidation]: {
        code: exports.GenerationFailureCode.SeedanceFalValidation,
        message: 'The video provider rejected the current prompt or reference assets. Retrying with the same inputs will not resolve it. Please adjust the prompt or reference assets before generating again.',
        presentation: {
            title: 'Video inputs rejected',
            summary: 'Adjust the prompt or reference assets before generating again. Retrying unchanged will not fix it.',
        },
    },
    [exports.GenerationFailureCode.SeedanceSensitiveOutput]: {
        code: exports.GenerationFailureCode.SeedanceSensitiveOutput,
        message: 'We couldn’t create this video because the result was flagged for sensitive content. This may be caused by the story described in your prompt or by the images, videos, or audio you provided. Please adjust them and try again.',
        presentation: {
            title: 'This video couldn’t be created',
            summary: 'The result was flagged for sensitive content. Try adjusting the story or the images, videos, or audio you provided.',
        },
    },
    [exports.GenerationFailureCode.SeedanceCopyrightRestriction]: {
        code: exports.GenerationFailureCode.SeedanceCopyrightRestriction,
        message: 'We couldn’t create this video because the generated result may contain copyrighted material. This may be caused by the story described in your prompt or by the images, videos, or audio you provided. Please adjust them and try again.',
        presentation: {
            title: 'This video couldn’t be created',
            summary: 'The result may contain copyrighted material. Try adjusting the story or the images, videos, or audio you provided.',
        },
    },
    [exports.GenerationFailureCode.HiggsfieldPlanRequired]: {
        code: exports.GenerationFailureCode.HiggsfieldPlanRequired,
        message: 'This Higgsfield model requires a Pro or Ultimate plan. Choose another Higgsfield model or upgrade your Higgsfield plan.',
        presentation: {
            title: 'Higgsfield plan required',
            summary: 'Choose another Higgsfield model, or upgrade your Higgsfield plan to Pro or Ultimate.',
        },
    },
};
const getGenerationFailureDefinitionForMessage = (message) => {
    const normalizedMessage = message?.trim();
    if (!normalizedMessage)
        return null;
    return (Object.values(exports.GENERATION_FAILURE_DEFINITIONS_BY_CODE).find((definition) => definition.message === normalizedMessage) ?? null);
};
exports.getGenerationFailureDefinitionForMessage = getGenerationFailureDefinitionForMessage;
